import * as Excel from 'exceljs/dist/exceljs';
import { saveAs } from 'file-saver';
import { getDownloadData, getDownloadDataWithCalculatedValues, wpidFetchDataToDownload } from './apiService';

var _ = require('lodash');

function getCurrentDayName() {
  const daysOfWeek = [
    "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
  ];
  return daysOfWeek[new Date().getDay()];
}

async function downloadInventoryData(itemsList, selectedDCs, exportType) {
  try {
    const timestampStr = (new Date()).toLocaleString();
    const inventoryTableData = exportType === 'meat'
      ? await getDownloadDataWithCalculatedValues(itemsList, selectedDCs)
      : await getDownloadData(itemsList, selectedDCs);
    const workbook = await configWorkbookForInventoryTableData(itemsList, inventoryTableData, exportType);
    await writeFileAndDownload(workbook, `DDIR-${timestampStr}.xlsx`);
  } catch (error) {
    console.error('Download failed:', error);
  }
}

async function configWorkbookForInventoryTableData(_itemsList, inventoryTableData, exportType) {
  let workbook = new Excel.Workbook();
  const ws = workbook.addWorksheet("Sheet1", { views: [{ state: 'frozen', xSplit: 0, ySplit: 1 }] });

  if (exportType === 'meat') {
    const skuInfoHeaders = ['DC', 'Item', 'Desc', 'WM WK', 'Day'];
    const currentWeekHeaders = [
      'Sat Short', 'Sun Short', 'Mon Short', 'Tues Short', 'Wed Short', 'Thurs Short', 'Fri Short',
      'Sat Rec Diff', 'Sun Rec Diff', 'Mon Rec Diff', 'Tues Rec Diff', 'Wed Rec Diff', 'Thurs Rec Diff', 'Fri Rec Diff',
      'Sat Demand', 'Sun Demand', 'Mon Demand', 'Tues Demand', 'Wed Demand', 'Thurs Demand', 'Fri Demand',
      'Current Week Inventory Check', 'Current Week Inventory', 'Current Week Inv Diff'
    ];
    const lastWeekHeaders = [
      'Last Week Total Demand',
      'Last Week Inventory Check',
      'Last Week Inventory',
      'Last Week Inventory Diff'
    ];
    const nextWeekHeaders = [
      'Next Week Ordered'
    ];

    const headerRow = [
      ...skuInfoHeaders,
      ...currentWeekHeaders,
      ...lastWeekHeaders,
      ...nextWeekHeaders
    ];
    ws.addRow(headerRow);

    const columnWidths = [
      10,
      12,
      30,
      10,
      10,
      ...Array(currentWeekHeaders.length).fill(25),
      ...Array(lastWeekHeaders.length).fill(25),
      ...Array(nextWeekHeaders.length).fill(25)
    ];

    ws.columns = columnWidths.map(width => ({ width }));

    const skuInfoFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEFEFEF' } };
    const currentWeekFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDFFFD6' } };
    const lastWeekFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD6E6FF' } };
    const nextWeekFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFE6E6' } };

    for (let i = 1; i <= skuInfoHeaders.length; i++) {
      ws.getRow(1).getCell(i).fill = skuInfoFill;
    }
    for (let i = skuInfoHeaders.length + 1; i <= skuInfoHeaders.length + currentWeekHeaders.length; i++) {
      ws.getRow(1).getCell(i).fill = currentWeekFill;
    }
    for (let i = skuInfoHeaders.length + currentWeekHeaders.length + 1;
      i <= skuInfoHeaders.length + currentWeekHeaders.length + lastWeekHeaders.length; i++) {
      ws.getRow(1).getCell(i).fill = lastWeekFill;
    }
    for (let i = skuInfoHeaders.length + currentWeekHeaders.length + lastWeekHeaders.length + 1;
      i <= skuInfoHeaders.length + currentWeekHeaders.length + lastWeekHeaders.length + nextWeekHeaders.length; i++) {
      ws.getRow(1).getCell(i).fill = nextWeekFill;
    }

    for (let [dc, dcItemData] of inventoryTableData) {
      for (let [item, itemDataArr] of dcItemData) {
        let selectedItem = JSON.parse(item);

        const sortedWeeks = itemDataArr.sort((a, b) => a.week - b.week);
        const lastWeek = sortedWeeks[0];
        const currentWeek = sortedWeeks[1];
        const nextWeek = sortedWeeks[2];

        const lastWeekDemandData = lastWeek?.data?.demand || Array(7).fill('');

        const lastWeekRow = [
          dc,
          selectedItem['itemNbr'],
          selectedItem['itemDesc'],
          lastWeek?.week ?? '',
          getCurrentDayName(),

          ...Array(7).fill(''),
          ...Array(7).fill(''),
          ...lastWeekDemandData.slice(0, 7),
          ...Array(3).fill(''),

          currentWeek?.meatBuyingExportData?.lastWeekTotalDemand ?? '',
          currentWeek?.meatBuyingExportData?.lastWeekInventoryCheck ?? '',
          currentWeek?.meatBuyingExportData?.lastWeekInventory ?? '',
          currentWeek?.meatBuyingExportData?.lastWeekInventoryDiff ?? '',

          ...Array(nextWeekHeaders.length).fill('')
        ];
        ws.addRow(lastWeekRow);

        ws.addRow(['']);
        ws.addRow(['']);
        ws.lastRow.border = {
          top: { style: 'thin', color: { argb: 'FF000000' } }
        };

        const meatBuyingData = currentWeek?.meatBuyingExportData || {};

        const currentWeekRow = [
          dc,
          selectedItem['itemNbr'],
          selectedItem['itemDesc'],
          currentWeek?.week ?? '',
          getCurrentDayName(),

          ...(meatBuyingData.dailyShort || Array(7).fill('')).slice(0, 7),
          ...(meatBuyingData.dailyRecDiff || Array(7).fill('')).slice(0, 7),
          ...(meatBuyingData.dailyDemand || Array(7).fill('')).slice(0, 7),
          meatBuyingData.inventoryCheck ?? '',
          meatBuyingData.inventory ?? '',
          meatBuyingData.inventoryDiff ?? '',

          ...Array(lastWeekHeaders.length).fill(''),

          ...Array(nextWeekHeaders.length).fill('')
        ];
        ws.addRow(currentWeekRow);

        ws.addRow(['']);
        ws.addRow(['']);
        ws.lastRow.border = {
          top: { style: 'thin', color: { argb: 'FF000000' } }
        };

        const nextWeekRow = [
          dc,
          selectedItem['itemNbr'],
          selectedItem['itemDesc'],
          nextWeek?.week ?? '',
          getCurrentDayName(),

          ...Array(currentWeekHeaders.length).fill(''),

          ...Array(lastWeekHeaders.length).fill(''),

          currentWeek?.meatBuyingExportData?.nextWeekOrdered ?? ''
        ];
        ws.addRow(nextWeekRow);

        ws.addRow(['']);
        ws.addRow(['']);
        ws.lastRow.border = {
          top: { style: 'double', color: { argb: 'FF000000' } }
        };
      }
    }
  } else {
    // STANDARD EXPORT
    ws.addRow(['', 'DC', 'ITEM', 'DESC', 'COMMENTS', 'SAT', 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'TOTAL']);

    for (let [dc, dcItemData] of inventoryTableData) {
      for (let [item, itemDataArr] of dcItemData) {
        let selectedItem = JSON.parse(item);
        for (let weeklyData of itemDataArr) {
          let legacyCmtText = weeklyData['commentObj']?.['legacyCmtText'] ?? '';
          let commentTxt = weeklyData['commentObj']?.['commentTxt'] ?? '';

          ws.addRow(['DC-NBR', '', '', '', '', dc, 'ITEM', selectedItem['itemNbr'], 'DESC', selectedItem['itemDesc']]);
          ws.addRow(['YR/WK', '', '', '', '', 'SAT', 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'TOTAL']);
          ws.addRow([
            String(weeklyData['year']) + '/' + String(weeklyData['week']),
            '', '', '', '',
            ...(weeklyData['date'] ?? [])
          ]);

          if (weeklyData['data']?.['demand']) {
            ws.addRow([
              'DEMAND', dc, selectedItem['itemNbr'], selectedItem['itemDesc'], legacyCmtText,
              ...weeklyData['data']['demand'],
              getSum(weeklyData['data']['demand'])
            ]);
          } else {
            ws.addRow([]);
          }

          if (weeklyData['data']?.['ordered']) {
            ws.addRow([
              'ORDERED', '', '', '', commentTxt,
              ...weeklyData['data']['ordered'],
              getSum(weeklyData['data']['ordered'])
            ]);
          } else {
            ws.addRow([]);
          }

          if (weeklyData['data']?.['received']) {
            ws.addRow([
              'RECEIVED', '', '', '', '',
              ...weeklyData['data']['received'],
              getSum(weeklyData['data']['received'])
            ]);
          } else {
            ws.addRow([]);
          }

          if (weeklyData['data']?.['inventory']) {
            ws.addRow([
              'INVENTORY', '', '', '', '',
              ...weeklyData['data']['inventory'],
              getAvg(weeklyData['data']['inventory'])
            ]);
          } else {
            ws.addRow([]);
          }

          if (weeklyData['data']?.['sales']) {
            ws.addRow([
              'SALES', '', '', '', '',
              ...weeklyData['data']['sales'],
              getSum(weeklyData['data']['sales'])
            ]);
          } else {
            ws.addRow([]);
          }

          ws.addRow(['']);
          ws.addRow([]);

          ws.lastRow.border = {
            top: { style: 'double', color: { argb: 'FF000000' } }
          };
        }
      }
    }
  }

  return workbook;
}

function getSum(arr) {
  if (!arr || !Array.isArray(arr)) return 0;
  return _.sum(arr.filter(val =>
    val !== null &&
    val !== undefined &&
    val !== '' &&
    !Number.isNaN(Number(val))
  ));
}

function getAvg(arr) {
  if (!arr || !Array.isArray(arr)) return 0;
  const validValues = arr.filter(val =>
    val !== null &&
    val !== undefined &&
    val !== '' &&
    !Number.isNaN(Number(val))
  );
  return validValues.length > 0 ? Math.round(_.mean(validValues)) : 0;
}

async function downloadWpidInventoryData(selectedItem, selectedDCs) {
  try {
    const timestampStr = (new Date()).toLocaleString();
    const inventoryTableData = await wpidFetchDataToDownload(selectedItem.wpidNbr, selectedDCs);
    const workbook = await configWorkbookForWpidInventoryData(selectedItem, inventoryTableData);
    await writeFileAndDownload(workbook, `DDIR-WPID-${timestampStr}.xlsx`);
  } catch (error) {
    console.error('WPID Download failed:', error);
    throw error;
  }
}

async function configWorkbookForWpidInventoryData(selectedItem, inventoryTableData) {
  let workbook = new Excel.Workbook();
  const ws = workbook.addWorksheet("Sheet1", { views: [{ state: 'frozen', xSplit: 0, ySplit: 1 }] });

  ws.addRow(['', 'DC', 'WPID', 'DESC', 'COMMENTS', 'SAT', 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'TOTAL']);

  for (let [dc, weekTableArr] of inventoryTableData) {
    for (let weeklyData of weekTableArr) {
      let legacyCmtText = weeklyData['commentObj']?.['legacyCmtText'] ?? '';
      let commentTxt = weeklyData['commentObj']?.['commentTxt'] ?? '';

      ws.addRow(['DC-NBR', '', '', '', '', dc, 'WPID', selectedItem.wpidNbr, 'DESC', selectedItem.itemDesc]);
      ws.addRow(['YR/WK', '', '', '', '', 'SAT', 'SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'TOTAL']);
      ws.addRow([
        String(weeklyData['year']) + '/' + String(weeklyData['week']),
        '', '', '', '',
        ...(weeklyData['date'] ?? [])
      ]);

      if (weeklyData['data']?.['demand']) {
        ws.addRow([
          'DEMAND', dc, selectedItem.wpidNbr, selectedItem.itemDesc, legacyCmtText,
          ...weeklyData['data']['demand'],
          getSum(weeklyData['data']['demand'])
        ]);
      } else {
        ws.addRow([]);
      }

      if (weeklyData['data']?.['ordered']) {
        ws.addRow([
          'ORDERED', '', '', '', commentTxt,
          ...weeklyData['data']['ordered'],
          getSum(weeklyData['data']['ordered'])
        ]);
      } else {
        ws.addRow([]);
      }

      if (weeklyData['data']?.['received']) {
        ws.addRow([
          'RECEIVED', '', '', '', '',
          ...weeklyData['data']['received'],
          getSum(weeklyData['data']['received'])
        ]);
      } else {
        ws.addRow([]);
      }

      if (weeklyData['data']?.['inventory']) {
        ws.addRow([
          'INVENTORY', '', '', '', '',
          ...weeklyData['data']['inventory'],
          getAvg(weeklyData['data']['inventory'])
        ]);
      } else {
        ws.addRow([]);
      }

      if (weeklyData['data']?.['sales']) {
        ws.addRow([
          'SALES', '', '', '', '',
          ...weeklyData['data']['sales'],
          getSum(weeklyData['data']['sales'])
        ]);
      } else {
        ws.addRow([]);
      }

      ws.addRow(['']);
      ws.addRow([]);

      ws.lastRow.border = {
        top: { style: 'double', color: { argb: 'FF000000' } }
      };
    }
  }

  return workbook;
}

async function writeFileAndDownload(workbook, filename) {
  const buf = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buf]), filename);
}

export { downloadInventoryData, downloadWpidInventoryData };
